import MarkerConfiguration from './MarkerConfiguration'

import './style.scss'

export { MarkerConfiguration }
export default MarkerConfiguration
